import { createEntityReducer } from "@selas/state-management";
import Endpoint from "../../services/api/endpoint";
import { IOpportunityNote } from "../../utils/types/models";

export default createEntityReducer<IOpportunityNote>(Endpoint.OpportunityNotes, Endpoint.OpportunityNotesList);
